import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { closePosShift } from '../../../api/posShifts/closePosShift';
import Confirmation from '../../../components/Confirmation';
import PrimaryButton from '../../../components/PrimaryButton';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import { useSnackbar } from '../../../contexts/snackbar.context';
import currency from '../../../utils/currency';

const CloseShiftButton = () => {
  const { lang } = useLocale();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { cafeSlug, cafe } = useAdmin();
  const { worker, wallets, currentPosShift, legalEntities } = useCafe();
  const { addSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    setLoading(true);

    const { errors } = await closePosShift({
      posShift: currentPosShift,
      worker,
      wallets,
      cafe,
      cafeSlug,
      legalEntities,
    });

    if (errors?.length) {
      errors.forEach((e) => addSnackbar(e, 'error'));
    }

    setLoading(false);
  };

  return (
    <>
      <PrimaryButton
        onClick={() => setOpen(true)}
        disabled={loading || !worker?.credentials.open_close_pos_shifts}
        color="secondary"
      >
        {t.close_shift[lang]}
      </PrimaryButton>

      <Confirmation
        title={t.close_shift[lang]}
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        submitButtonTitle={t.close_shift[lang]}
        cancelButtonTitle={t.cancel[lang]}
        text={
          <Box>
            <Typography sx={{ mb: 1 }}>{t.check_cash_balance_before_closing[lang]}.</Typography>
            {wallets
              .filter((w) => !w.hidden)
              .map((w) => (
                <Typography key={w.id}>
                  <strong>{w.name}</strong>: {currency(w.balance, cafe?.currency)}
                </Typography>
              ))}
          </Box>
        }
      />
    </>
  );
};

export default CloseShiftButton;
